export const liveStreamModal = val => {
    return {type: val};
};